var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('HeroComponent'),_c('SeccionLecturas'),_c('SeccionRitual'),_c('SeccionProceso'),_c('FooterComponent')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }